import * as React from 'react';
import { useSelector } from 'react-redux';
import { get, getConfig } from '../../../helpers';
import RequestTrialDefault from '../../request-a-trial-form/default-form';
import RequestTrialPlatts from '../../request-a-trial-form/platts-form';
import RequestTrialEmail from '../../request-a-trial-form/email-form';
import RequestTrialCrisil from '../../request-a-trial-form/crisil-form';
import RequestTrialIHSMarkit from '../../request-a-trial-form/ihs-markit-form';
import RequestTrialCommunique from '../../request-a-trial-form/communique-form';
import RequestTrialSwitch from '../../request-a-trial-form/switch-form';
import RequestTrialVisualization from '../../request-a-trial-form/visualization-form';
import RequestCoalitionTrialEmail from '../../request-a-trial-form/email-coalition-form';
import RequestTrialMobilityForm from '../../request-a-trial-form/mobility-form';
import HelmetManager from '../../_common/helmet-manager';


function getVariant(productVariant: string, dataProvider: string, productId: string): string {
    const productVariantFirstCharUpperCase = () => {
        const arr = productVariant.split('');
        arr[0] = arr[0].toUpperCase();
        return arr.join('');
    };
    const dataProviderVariant = getConfig(`components.request-a-trial.${productVariant}`).dataProviderVariant as DataProviderVariant[];
    const stateConfig: { IdVariant: any[] } = useSelector((state: RootStoreState) => get(state, 'shared.config.data', false))[productVariantFirstCharUpperCase()];
    if (stateConfig && productId && stateConfig.IdVariant && stateConfig.IdVariant.some((variant: IdVariant) => variant && variant.Id.includes(productId))) {
        return stateConfig.IdVariant.filter((variant: IdVariant) => variant.Id.includes(productId))[0].Variant;
    }
    if (
        dataProvider &&
        dataProviderVariant &&
        dataProviderVariant.some(variant => variant && variant.dataProvider === dataProvider)
    ) {
        return dataProviderVariant.filter(variant => variant && variant.dataProvider === dataProvider)[0].variant;
    }
    if (dataProviderVariant && dataProviderVariant.some(variant => variant && variant.dataProvider === 'default')) {
        return dataProviderVariant.filter(variant => variant && variant.dataProvider === 'default')[0].variant;
    }
    if (productVariant === 'blueprint') {
        return 'blueprint';
    }
    if (productVariant === 'contactUs') {
        return 'contactUs';
    }
    return 'dataset';
}

function RequestTrialFormProvider(props: RequestTrialFormProviderProps) {
    const { productName = '', productId = '', dataProvider = '', titleText, marketMSADataLink, dataFilePath, marketplaceMSATooltip, ratVariant, metaData } = props;
    let variant = '';
    const { productVariant = 'dataset' } = props;
    variant = getVariant(productVariant, dataProvider.toLowerCase(), productId) || 'dataset';
    const getRATform = () => {
        if (variant === 'platts') {
            return <RequestTrialPlatts productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'index' || variant === 'ratings' || variant === 'spglobal' || (variant === 'coalition' && productVariant === 'solution')) {
            return <RequestTrialEmail productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'crisil') {
            return <RequestTrialCrisil productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'ihs-markit') {
            return <RequestTrialIHSMarkit productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'coalition' && productVariant === 'dataset') {
            return <RequestCoalitionTrialEmail productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'mobility' && productVariant === 'dataset') {
            return <RequestTrialMobilityForm productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} ratVariant={ratVariant} />;
        }
        if (variant === 'communique') {
            return (
                <RequestTrialCommunique
                    productVariant={productVariant}
                    productName={productName}
                    titleText={titleText}
                    variant={variant}
                    marketMSADataLink={marketMSADataLink}
                    dataFilePath={dataFilePath}
                    marketplaceMSATooltip={marketplaceMSATooltip}
                    ratVariant={ratVariant}
                />
            );
        }
        if (variant === 'switch') {
            return (
                <RequestTrialSwitch
                    productVariant={productVariant}
                    productName={productName}
                    titleText={titleText}
                    variant={variant}
                    marketMSADataLink={marketMSADataLink}
                    dataFilePath={dataFilePath}
                    marketplaceMSATooltip={marketplaceMSATooltip}
                    ratVariant={ratVariant}
                />
            );
        }
        if (variant === 'visualization') {
            return <RequestTrialVisualization productVariant={productVariant} productName={productName} titleText={titleText} variant={variant} />;
        }
        return (
            <RequestTrialDefault
                productVariant={productVariant}
                productName={productName}
                titleText={titleText}
                variant={variant}
                marketMSADataLink={marketMSADataLink}
                dataFilePath={dataFilePath}
                marketplaceMSATooltip={marketplaceMSATooltip}
                ratVariant={ratVariant}
            />
        );
    };
    if (metaData) {
        return (
            <>
                <HelmetManager metaData={metaData} />
                {getRATform()}
            </>
        );
    }
    return <>{getRATform()}</>;
}

export default React.memo(RequestTrialFormProvider);
